import React, { useState } from "react";
import editIcon from "../../../assets/images/editIcon02.png"
import saveIcon from "../../../assets/images/Check.svg";
import clearIcon from "../../../assets/images/X.svg";
import { heightInFt, heightInInch } from "../../../constants";

const HeightField = ({ defaultFt, defaultInch, name, id, onChangeFt, onChangeInch,
  showEditIcon=false, saveEdit, required,
  onFieldBlur,
  onEditClick,
  onCancelEdit,
  label
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [updatedFt, setUpdatedFt] = useState('');
  const [updatedInch, setUpdatedInch] = useState('');
  const onFtChange = (value) => {
    if (showEditIcon) {
      setUpdatedFt(value)
    }
    onChangeFt(value)
  }

  const onInchChange = (value) => {
    if (showEditIcon) {
      setUpdatedInch(value)
    }
    onChangeInch(value)
  }

  const onSaveEdit = () => {
    if ((defaultFt === parseInt(updatedFt)) && (defaultInch === parseInt(updatedInch))) {
      setIsEditable(false);
    } else {
      const ft = updatedFt ? updatedFt : defaultFt ? defaultFt : 0;
      const inch = updatedInch ? updatedInch : defaultInch ? defaultInch : 0;
      let isValueEdited = false;
      if (defaultFt || defaultInch) {
        isValueEdited = defaultFt !== parseInt(updatedFt) || defaultInch !== parseInt(updatedInch);
      }
      saveEdit(id, parseInt(ft), parseInt(inch), isValueEdited)
      setIsEditable(false);
    }
  }

  const onBlur = (e) => {
    if (onFieldBlur && isEditable) {
      const next = e.relatedTarget;
      const isSaveOrCancel =
        next?.alt === "save edit" ||
        next?.alt === "clear edit" ||
        next?.closest(".save-cancel-wrapper");

      if (!e.currentTarget.contains(next) && !isSaveOrCancel) {
        onFieldBlur();
      }
    };
  };

  return (
    <div className={`flex ${showEditIcon ? 'justify-between' : 'justify-start'}`}>
      <div className='flex flex-row'>
        <select
          className="border-none w-auto outline-none text-sm text-left placeholder-grayNobel text-tileGray font-normal h-4 mt-2 mr-2 appearance-none"
          name={name}
          id={id}
          disabled={showEditIcon && !isEditable}
          required={required}
          onBlur={(e) => onBlur(e)}
          onChange={(e) => onFtChange(e.target.value)}>
          <option key="0" value="">Feet</option>
          {
            heightInFt.map((ft, index) => {
              return (
                <option key={index + 1} value={ft} selected={defaultFt === ft}>{ft}'</option>
              )
            })
          }
        </select>
        <select
          className="border-none w-auto outline-none text-sm text-left placeholder-grayNobel text-tileGray font-normal h-4 mt-2 appearance-none"
          name={name}
          id={id}
          disabled={showEditIcon && !isEditable}
          required={required}
          onBlur={(e) => onBlur(e)}
          onChange={(e) => onInchChange(e.target.value)}>
          <option key="0" value="">Inches</option>
          {
            heightInInch.map((inch, index) => {
              return (
                <option key={index + 1} value={index} selected={defaultInch === inch}>{inch}"</option>
              )
            })
          }
        </select>
      </div>
      {showEditIcon && !isEditable && (
        <button
          type="button"
          aria-label="edit"
          data-action="edit"
          className="ml-ten -mt-1"
          onClick={() => {
            setIsEditable(true);
            if (onEditClick) onEditClick(label, true);
          }}
        >
          <img src={editIcon} alt="edit" className="h-4 w-4 cursor-pointer" />
        </button>
      )}

      {isEditable && (
        <div className="save-cancel-wrapper grid -mt-5 gap-2">
          <button
            type="button"
            data-action="save"
            aria-label="save edit"
            className="w-4 h-4 cursor-pointer flex items-center justify-center"
            onClick={() => onSaveEdit()}
          >
            <img src={saveIcon} alt="save" className="w-4 h-4" />
          </button>

          <button
            type="button"
            data-action="cancel"
            aria-label="cancel edit"
            className="w-4 h-4 cursor-pointer flex items-center justify-center"
            onClick={() => {
              setUpdatedFt('');
              setUpdatedInch('');
              setIsEditable(false);
              if (onCancelEdit) onCancelEdit();
            }}
          >
            <img src={clearIcon} alt="cancel" className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  )
}

export default HeightField;